import {HttpClient} from "../../service/httpClient/HttpClient";

export class HabitationMonitoringService {

    constructor() {
        this.httpClient = new HttpClient()
    }


    getAccommodationReserveStatus(id) {
        return this.httpClient.get(
            `accommodation-period/${id}/accommodation-reservations/statuses/statistical`
        )
    }

    getAccommodationRequestsStatus(id) {
        return this.httpClient.get(
            `accommodation-period/${id}/accommodation-requests/statuses/statistical`
        )
    }

    getHostCapacities(id) {
        return this.httpClient.get(
            `accommodation-period/${id}/accommodation-hosts/capacities/statistical`
        )
    }

    getDailyPopulationReport(id) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `accommodation-period/${id}/accommodation-reservations/daily-population/statistical`
            ).then(resolve).catch(reject)
        })
    }

    getDailyCommutingReport(id) {
        return this.httpClient.get(
            `accommodation-period/${id}/accommodation-reservations/daily-commuting/statistical`
        )
    }

    getHostDailyPopulation(periodId, id) {
        return this.httpClient.get(
            `accommodation-period/${periodId}/accommodation-hosts/${id}/daily-population/statistical`,
        )
    }

    getHostDailyReservation(periodId, id) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `accommodation-period/${periodId}/accommodation-hosts/${id}/daily-commuting/statistical`,
            ).then(resolve).catch(reject)
        })
    }

    getProvincesPopulation(periodId) {
        return this.httpClient.get(
            `accommodation-period/${periodId}/accommodation-reservations/provinces-population/statistical`
        )
    }
}